import rtlStyle from "../src/styles/rtl.cssr.mjs";
export const scrollbarRtl = {
  name: 'Scrollbar',
  style: rtlStyle
};
export default scrollbarRtl;